__turbopack_context__.v({
  "add-to-wishlist-btn": "_7rBN4W_add-to-wishlist-btn",
  "shared-item-actions": "_7rBN4W_shared-item-actions",
  "shared-item-add": "_7rBN4W_shared-item-add",
  "shared-item-container": "_7rBN4W_shared-item-container",
  "shared-item-info": "_7rBN4W_shared-item-info",
  "shared-item-name": "_7rBN4W_shared-item-name",
  "shared-item-price": "_7rBN4W_shared-item-price",
  "wishlist-shared-container": "_7rBN4W_wishlist-shared-container",
});
